export default function buyTrainingLink(productId) {
  return `${process.env.NEXT_PUBLIC_STORE_HOST}/entrenamiento/carrito?producto=${productId}`;
}
